<div #modalOverlay class="modal-overlay"></div>
<div #modal class="modal fade" id="customModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [ngClass]="titleColor" id="modalLabel">{{ title }}</h5>
        <button #closeModal type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="actionCancel()"></button>
      </div>
      <div class="modal-body">
        @if (contentTemplate) {
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        } @else {
          <p class="modal-body-text" [ngClass]="bodyColor" [innerHTML]="body || ''"></p>
        }

        @if (showAuthForm) {
          <form [formGroup]="authForm">
            <div class="mb-3">
              <label for="username" class="form-label">Логин</label>
              <input id="username" type="text" class="form-control" formControlName="username" />
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Пароль</label>
              <input id="password" type="password" class="form-control" formControlName="password" />
            </div>
          </form>
        }
      </div>
      <div class="modal-footer d-flex justify-content-center">
        @if (cancelText) {
          <button type="button" class="btn btn-danger border" (click)="actionCancel()">{{ cancelText }}</button>
        }
        @if (confirmText) {
          <button type="button" class="btn btn-primary" (click)="actionConfirm()">{{ confirmText }}</button>
        }
      </div>
    </div>
  </div>
</div>
